import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { DContext } from "../../../context/Datacontext";

import Profiles from './Candidate Info/ViewProfiles';
import FloatingLoading from '../../blocks/Layout/Loading';
import { apiFetch } from '../../services/fetchApi';

export default function ViewCandidate() {
  const { BeURL, currentUser } = useContext(DContext);
  const { id } = useParams();

  const [candidate, setCandidate] = useState(null);
  const [consolidatedSkills, setConsolidatedSkills] = useState(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentHeader, setCurrentHeader] = useState('Overview')

  useEffect(() => {
    if (candidate?.skills && candidate.skills.length > 0) {
      setConsolidatedSkills(candidate.skills.map(item => item.skill))
    }
  }, [candidate])

  useEffect(() => {
    apiFetch(`${BeURL}/fetch-candidate/${id}`, {

    })
      .then(res => res.json())
      .then(json => {
        if (json.success) setCandidate(json.candidate);
        else throw new Error(json.message);
      })
      .catch(err => {
        console.log("Error:", err)
        setError(err.message)
      })
      .finally(() => setLoading(false));
  }, [BeURL, id]);

  if (loading) return <FloatingLoading />;
  if (error) return <div className="flex justify-center items-center h-full"><p className="text-red-600">Error: {error}</p></div>;

  // Destructure for display
  const { _id, applicantID, applicantName, applicantFullName, emailAddress, phoneNumber, experience, currentCTC, resumeAvailable, resumeLink } = candidate;

  const menuItems = [
    { label: "Pro Search", link: "/pro-search" },
    { label: applicantID, link: `/candidate/${applicantID}` },
  ]


  return (
    <div className="min-h-screen">

      <Profiles candidate={candidate} />

    </div>
  );
}

